/**
 * A hook that returns any subcategories for a given category.
 *
 * Takes an optional `categoryId`.
 *
 * - If no `categoryId` provided, it will try to find the current category with [[useCategory]].
 * - When a category is found, will return `category.subCategories`.
 *
 * @module
 */
import useCategory from './useCategory';
/**
 *
 * # useSubCategories
 *
 * Usage example:
 * ```javascript
 * import useSubCategories from '@elevio/kb-kit/lib/hooks/useSubCategories';
 *
 * const MyCategoryList = ({ categoryId }) => {
 *   const subCategories = useSubCategories(categoryId);
 *   if (!subCategories || subCategories.length === 0) return null;
 *
 *   return (
 *     <ul>
 *       {subCategories.map((subCat) => {
 *         return <li key={subCat.id}>{subCat.title}</li>;
 *       })}
 *     </ul>
 *   );
 * };
 * ```
 */
export default function useSubCategories(categoryId) {
    const category = useCategory(categoryId);
    if (!category)
        return;
    return category.subCategories;
}
//# sourceMappingURL=useSubCategories.js.map